import { Box } from '@mui/material'

import { GridColDef, useGridApiRef } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import { autoHeight } from 'Common/utils/utils'
import { Table } from 'Common/MUITable/MUITable'
import { DataQualityTableProps } from './DataQuality.types'

const planHorizonWeeks = 52

export const DataQualityMUITable = ({
  data,
  handleColumnClick,
}: DataQualityTableProps) => {
  const apiRef = useGridApiRef()
  const onRowSelection = () => {}

  const columns: GridColDef[] = useMemo(
    () => [
      {
        headerName: 'Workcentre code',
        field: 'workCentreCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'No of skus',
        field: 'numberOfProducts',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Invalid skus',
        field: 'invalidSkus',
        flex: 1,
        type: 'number',
        cellClassName: 'clcik-through-column',
      },
      {
        headerName: 'Orphan Demand',
        field: 'orphanSkus',
        flex: 1,
        type: 'number',
        cellClassName: 'clcik-through-column',
      },
      {
        headerName: 'Missing changeovers',
        field: 'missingChangeOvers',
        flex: 1,
        type: 'number',
        cellClassName: 'clcik-through-column',
      },
      {
        headerName: 'Missing batches',
        field: 'missingBatches',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Inventory date',
        field: 'inventoryDate',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Forecast date',
        field: 'forecastDate',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Planned production amount',
        field: 'plannedProductionAmount',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Stock in transit',
        field: 'stockInTransit',
        flex: 1,
        type: 'number',
      },
      {
        headerName: 'Workcentre capacity',
        field: 'workCentreCapacity',
        flex: 1,
        type: 'number',
        cellClassName: (params) => {
          const capacity = parseInt(params.value)
          if (capacity < planHorizonWeeks) {
            return 'red-column'
          }
          return ''
        },
      },
    ],
    [data]
  )
  return (
    <Box>
      <Box
        id="#table-container-mui"
        sx={{
          '& .clcik-through-column': {
            backgroundColor: '#CBD5E1',
            cursor: 'pointer',
          },
          '& .red-column': {
            color: '#FF0000',
          },
        }}
      >
        <Table
          ref={autoHeight}
          apiRef={apiRef}
          rows={data ?? []}
          columns={columns}
          showCellVerticalBorder
          showColumnVerticalBorder
          pagination
          initialState={{
            pagination: { paginationModel: { pageSize: 100 } },
          }}
          pageSizeOptions={[25, 50, 100]}
          onRowSelectionModelChange={onRowSelection}
          onCellClick={handleColumnClick}
        />
      </Box>
    </Box>
  )
}
